export default __webpack_public_path__ + "static/media/monsta-logo.aeec7f77.png";